import { isBoolean } from 'lodash-es'
import { signUserFunction } from './gallery-properties.flow'

export default signUserFunction(calcCarouselScrollbarOverlay)

function calcCarouselScrollbarOverlay(rawVal, calcProp) {
  if (isBoolean(rawVal)) {
    return rawVal
  }

  const post_space = calcProp('post_space')
  const body_side_margin = calcProp('body_side_margin')
  const carousel_scrollbar_size = calcProp('carousel_scrollbar_size')
  const spaceBelowContent = Math.ceil(post_space / 2) + body_side_margin
  const carousel_scrollbar_overlay = spaceBelowContent >= (carousel_scrollbar_size * 1.5)
  return carousel_scrollbar_overlay
}
